import { useState } from "react";
import { sendPushNotification } from "../api/common.api";
import { PushScreen } from "../types/type";

export const usePushNotificationForm = () => {
  const [title, setTitle] = useState<string>("제조 완료");
  const [content, setContent] = useState<string>("");
  const [screen, setScreen] = useState<PushScreen>("Home");
  const [type, setType] = useState<string>("제조완료");
  const [songId, setSongId] = useState<string>("0");
  const [songIdError, setSongIdError] = useState<string>("");
  const [token, setToken] = useState<string>("");
  const [tokenError, setTokenError] = useState<string>("");

  const validateSongId = (id: string) => {
    return /^[0-9]{5}$/.test(id) || id === "0" || id === "-1";
  };

  const validateToken = (token: string) => {
    return !/\s/.test(token);
  };

  const handleSongIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSongId(e.target.value);
    if (songIdError) {
      setSongIdError("");
    }
  };

  const handleScreenChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedScreen = e.target.value as PushScreen;
    setScreen(selectedScreen);
  };

  const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setType(e.target.value);
  };

  const handleSingleSendNotification = async ({
    onSuccess,
    onError,
    token,
    type,
    screen,
    songId,
    title,
    content,
  }: {
    onSuccess?: () => void;
    onError?: (error?: any) => void;
    token: string;
    screen: PushScreen;
    type: string;
    songId: string;
    title: string;
    content: string;
  }) => {
    let valid = true;

    if (!validateSongId(songId)) {
      setSongIdError(
        "SongId는 00000에서 99999 사이의 5자리 숫자 문자열이거나 '0', '-1'이어야 합니다."
      );
      valid = false;
    } else {
      setSongIdError("");
    }

    if (!validateToken(token)) {
      setTokenError("Token에는 띄어쓰기가 포함될 수 없습니다.");
      valid = false;
    } else {
      setTokenError("");
    }

    if (!valid) return;

    const body = {
      title: title,
      body: content,
      tokenList: [token],
      data: {
        songTitle: "custom",
        screen: screen, // 선택된 screen 값 사용
        type: type,
        songId: songId,
      },
    };

    try {
      await sendPushNotification(body);
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error(error);
      if (onError) onError(error);
    }
  };

  return {
    title,
    setTitle,
    content,
    setContent,
    screen,
    setScreen,
    type,
    setType,
    songId,
    setSongId,
    songIdError,
    setSongIdError,
    token,
    setToken,
    tokenError,
    setTokenError,
    validateSongId,
    handleSongIdChange,
    handleScreenChange,
    handleTypeChange,
    handleSingleSendNotification,
  };
};
